<template>
  <div>
    <title-bar />
    <app-main/>
    <contact-us />
    <home-footer />
    <bottom-bar />
  </div>
</template>

<script>
import HomeFooter from './components/page-footer'
import ContactUs from './components/contact-us'
import TitleBar from './components/title-bar'
import AppMain from './components/AppMain'
import BottomBar from './components/bottom-bar'

export default {
  name: 'Layout',
  components: {
    HomeFooter,
    ContactUs,
    TitleBar,
    AppMain,
    BottomBar
  }
}
</script>



// WEBPACK FOOTER //
// src/Layout/index.vue